
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[url_slug]",
      function () {
        return require("private-next-pages/projects/[url_slug]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[url_slug]"])
      });
    }
  